module.exports = __webpack_public_path__ + "3cf19cdf2ea877bb545b6223c7109a34.woff";